import { useEffect } from 'react';
import { Modal } from 'antd';
import SweetAlert from '@components/Feedback/SweetAlert/Index';
import ButtonComp from '@components/UI/Button/Index';
import { useForm } from 'react-hook-form';
import { UpdateObservacoesItemProcesso } from '@services/SolicitacaoProcessoItem/Index';
import TextAreaModalComp from '@components/UI/TextAreaModal/Index';
import { useDispatch } from 'react-redux';
import { atualizarObservacao } from '@store/slices/observacoesSlice';
import { perfisAdmin, perfisUnidadeGerencia } from '@utils/auth/perfis';
import { useAppAuth } from '@contexts/AuthContext';

const ObservacoesModal = ({
    visible,
    idProcessoItem,
    idSolicitacao,
    existingObservacoes,
    nomeItemProcesso,
    closeModal,
}) => {
    const {
        register,
        handleSubmit,
        reset,
        setValue,
    } = useForm();

    const { role } = useAppAuth();

    const isUnidadeGerencia = perfisUnidadeGerencia.includes(role);
    const isAdmin = perfisAdmin.includes(role); 

    const dispatch = useDispatch();

    useEffect(() => {
        if (existingObservacoes) {
            setValue('observacoes', existingObservacoes);
        } else {
            reset();
        }
    }, [existingObservacoes, setValue, reset]);

    const onSubmit = async (data) => {
        try {
            const payload = {
                idProcessoItem: idProcessoItem,
                observacoes: data.observacoes || "",
            };

            SweetAlert.toastLoading();

            await UpdateObservacoesItemProcesso(idSolicitacao, payload);

            SweetAlert.toastSuccessWithSubtitle(
                "Observação cadastrada!", 
                `A observação do item do processo '${nomeItemProcesso}' foi cadastrada com sucesso.`
            );

            dispatch(atualizarObservacao(payload));

            closeModal();
        } catch (error) {
            console.error("Erro ao atualizar observação:", error);
            SweetAlert.toastError("Erro ao atualizar a observação do item do processo.");
        }
    };

    return (
        <div className='d-flex justify-content-center gap-2'>
            <Modal
                getContainer={false}
                open={visible}
                onCancel={closeModal}
                footer={null}
                centered
                width={800}
                title={<span style={{ color: '#495058', fontWeight: 'bold', fontSize: 16 }}>Observações</span>}
            >
                <p className="fs-6 mb-3">
                    <strong>Item do Processo:</strong> {nomeItemProcesso}
                </p>

                <TextAreaModalComp
                    label="Observações (Texto Simples)"
                    {...register("observacoes")}
                    hoverMessage={isUnidadeGerencia ? "Campo apenas de visualização." : "Descreva aqui observações acerca do item do processo"}
                    placeholder={isUnidadeGerencia ? "Nenhuma observação existente." : "Descreva aqui observações acerca do item do processo"}
                    maxLength={256}
                    style={{ height: '15rem', resize: 'none' }}
                    disabled={!isAdmin}
                />

                {isAdmin && (
                    <div className="d-flex justify-content-end gap-2 mt-4">
                        <ButtonComp
                            title="SALVAR"
                            onClick={handleSubmit(onSubmit)}
                            buttonColor="#2b97be"
                            classnameIcon="fa-regular fa-floppy-disk"
                            hoverMessage="Salvar alterações"
                        />
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default ObservacoesModal;
